import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=46914d15&scoped=true&"
import script from "./ChangeHistory.vue?vue&type=script&lang=js&"
export * from "./ChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=46914d15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46914d15",
  null
  
)

export default component.exports